import { selectOptions } from 'store/options';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export default function useReviewCycleOptions() {
  const options = useSelector(selectOptions);

  return useMemo(() => options.reviewCycles, [options.reviewCycles]);
}
